import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../store/authStore";
import { Button } from "../components/common/UI";
import { IconTarget } from "../components/common/Icons";
import styles from "./Login.module.css";

export default function Login() {
  const navigate = useNavigate();
  const doLogin = useAuthStore((s) => s.login);
  const error = useAuthStore((s) => s.error);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const ok = await doLogin(username.trim(), password);
    setBusy(false);
    if (ok) navigate("/");
  };

  return (
    <div className={styles.wrap}>
      <form className={styles.card} onSubmit={submit}>
        <div className={styles.brand}>
          <IconTarget width={30} height={30} />
          <div>
            <div className={styles.title}>Дашборд акселерации</div>
            <div className={styles.sub}>Единая точка управления экосистемой</div>
          </div>
        </div>
        <div className={styles.field}>
          <label>Имя</label>
          <input value={username} onChange={(e) => setUsername(e.target.value)} autoFocus />
        </div>
        <div className={styles.field}>
          <label>Пароль</label>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>
        {error && <div className={styles.error}>{error}</div>}
        <Button type="submit" disabled={busy}>
          {busy ? "Вход…" : "Войти"}
        </Button>
      </form>
    </div>
  );
}
